module.exports = __webpack_public_path__ + "static/media/funcionamiento.ad17a909.svg";